import { breakpoints, spacing } from '@naf/theme';
import styled from '@emotion/styled';

export const MobileBenefitListWrapper = styled.div`
  width: 100%;
  overflow: visible;

  @media (max-width: ${breakpoints.m}) {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    overflow-x: hidden;
  }
`;

export const ScrollableWrapper = styled.div`
  display: flex;
  gap: ${spacing.space24};

  @media (max-width: ${breakpoints.m}) {
    gap: ${spacing.space16};
    padding: 0 ${spacing.space16};
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    padding-bottom: ${spacing.space16};

    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    > * {
      scroll-snap-align: center;
      flex: 0 0 auto;
      width: 280px;
      margin-top: ${spacing.space12};
    }

    > *:first-child {
      margin-left: 2px;
    }

    > *:last-child {
      margin-right: 2px;
    }
  }
`;
